import type { ListItemProps as MuiListItemProps } from '@mui/material';
import { ListItem as MuiListItem } from '@mui/material';

export type ListItemProps = MuiListItemProps;

/** ListItem component. Based on MUI ListItem: https://mui.com/material-ui/api/list-item/ */
export const ListItem = (props: ListItemProps) => <MuiListItem {...props} data-testid="listitem" />;
